module.exports = __webpack_public_path__ + "media/Images/icon-money-o-1bb1323f8737a30af055d1a7690e3339.svg";